import { render, staticRenderFns } from "./bastConfirmation.vue?vue&type=template&id=0b64be3e&scoped=true"
import script from "./bastConfirmation.vue?vue&type=script&lang=js"
export * from "./bastConfirmation.vue?vue&type=script&lang=js"
import style0 from "./bastConfirmation.vue?vue&type=style&index=0&id=0b64be3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64be3e",
  null
  
)

export default component.exports